var map = {
	"./meal1.webp": 642,
	"./meal10.webp": 936,
	"./meal11.webp": 76,
	"./meal12.webp": 509,
	"./meal13.webp": 914,
	"./meal14.webp": 437,
	"./meal15.webp": 823,
	"./meal16.webp": 445,
	"./meal17.webp": 225,
	"./meal18.webp": 841,
	"./meal19.webp": 878,
	"./meal2.webp": 203,
	"./meal20.webp": 54,
	"./meal21.webp": 3,
	"./meal22.webp": 986,
	"./meal23.webp": 4,
	"./meal25.webp": 492,
	"./meal26.webp": 797,
	"./meal27.webp": 689,
	"./meal28.webp": 854,
	"./meal29.webp": 632,
	"./meal3.webp": 525,
	"./meal4.webp": 879,
	"./meal5.webp": 654,
	"./meal6.webp": 185,
	"./meal7.webp": 248,
	"./meal8.webp": 229,
	"./meal9.webp": 894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 877;